document.addEventListener('DOMContentLoaded', (event) => {
    const footer = document.querySelector('.footer');
    const content = document.querySelector('.content');
    const header = document.querySelector('.header');
    let footerHeight = 0;
    let headerHeight = 0;
    if (footer instanceof HTMLElement) {
        footerHeight = footer.getBoundingClientRect().height;
    }
    if (header instanceof HTMLElement) {
        headerHeight = header.getBoundingClientRect().height;
    }
    if (content instanceof HTMLElement) {
        const globalHeight = footerHeight + headerHeight;
        content.style.minHeight = `calc(100vh - ${globalHeight}px)`;
    }
    function checkFormUrl() {
        if (window.location.href.indexOf('customer_posted=') > -1 || window.location.href.indexOf('?contact%5Btags%5D=prospect%2Cnewsletter&form_type=customer') > -1) {
            const footerNewsletterForms = document.querySelectorAll('[data-newsletter-form]');
            if (footerNewsletterForms.length > 0) {
                Array.from(footerNewsletterForms).forEach((footerNewsletterForm) => {
                    const submitMessage = document.querySelector('.footer__newsletter-wrapper');
                    submitMessage.innerHTML = `<p class="footer__newsletter-success">${dataJs.footer.newsletterSuccess}</p>`;
                    window.scrollTo({
                        top: footerNewsletterForm.getBoundingClientRect().top,
                        left: 0,
                        behavior: 'smooth',
                    });
                });
            }
        }
        else if (window.location.href.includes('/challenge#contact_form')) {
            window.scrollTo({
                top: header.getBoundingClientRect().top,
                left: 0,
                behavior: 'smooth',
            });
        }
    }
    window.addEventListener('load', () => {
        checkFormUrl();
    });
});
